<template>
  <div class="home">
    <!-- <div id="nav">
      <div class="bgc">
        <p><img src="@/assets/one.png"> 金晟保险经纪有限公司</p>
      </div>
    </div>
    <div class="contain" id='proudct1'>
      <div class="contain-header" style="margin-top: 40px;box-sizing: border-box;padding: 40px 0 40px 0;
      ">
        <div class="con">
          <p>公司介绍</p>
          <span></span>
        </div>
        <div class="text">
          <p style="text-indent: 2rem;line-height:3rem;">欢迎进入金晟e保公众号平台，点击立即投保进入保险产品页面</p>
        </div>
      </div>
    </div> -->
    <div class="contain" id='proudct1'>
      <div class="contain-header" style="margin-top: 0px;box-sizing: border-box;padding: 0px 0 40px 0;
      ">
        <!-- <div class="con">
          <p style="color: red;">温馨提示</p>
          <span></span>
        </div> -->
        <div class="text">
          <img src="@/assets/wxts.jpg" alt="" style="width: 100%;height: 100%;">
          <!-- <p style="text-indent: 2rem;line-height:3rem;color: red;">尊敬的客户，为了不影响您的投标工作，请务必于投标截止日5天前完成投保信息填写及线下付款流程。</p> -->
        </div>
      </div>
    </div>
    <div class="footer-mian-fixed">
      <div class="right">
        <span>
          <router-link to="/information" style="color: white;text-decoration: none;">立即投保</router-link>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        a: 1
      }
    }
  }
</script>
<style scoped>
  .home {
    position: relative;
    height: 907px;
  }

  #nav {
    width: 100%;
    margin: 0 auto;
  }

  #nav .bgc {
    background: url(~@/assets/header.png) no-repeat;
    background-size: 100%;
    width: 100%;
    height: 635px;
    position: relative;
  }

  #nav .bgc p {
    width: 46%;
    border-radius: 50%;
    height: 60px;
    position: absolute;
    bottom: 20px;
    left: 30%;
    display: inline-block;
    margin: 0 auto;
    font-size: 39px;
  }

  #nav .bgc p img {
    height: 40px;
    object-fit: cover;
  }

  .contain {
    width: 100%;
  }

  .contain .contain-header {
    width: 95%;
    margin: 0 auto;
    background: #FFFFFF;
    box-shadow: 0px 26px 34px 0px rgba(171, 171, 171, 0.12);
    border-radius: 10px;
    margin: 0 auto;
  }

  .contain .contain-header h1 {
    width: 168px;
    height: 48px;
    font-size: 48px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 48px;
    letter-spacing: 8px;
    margin: 0 auto;
    position: relative;
    z-index: 3;
  }

  .contain .con {
    width: 144px;
    position: relative;
    margin: 40px 30px;
  }

  .contain .con p {
    width: 144px;
    height: 36px;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 36px;
    position: relative;
    z-index: 10;
  }

  .contain .text {
    width: 100%;
    margin: 0 auto;
    /* padding: 0px 10px 10px 10px; */
  }

  .contain .text p {
    width: 100%;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    letter-spacing: 5px;
  }

  .footer-mian-fixed {
    width: 100%;
    height: 100px;
    position: fixed;
    bottom: 0;
    background-color: #fff;
    z-index: 20;
    display: flex;
  }

  .footer-mian-fixed .right {
    width: 100%;
    background-color: #ee7800;
    font-size: 40px;
    line-height: 100px;
    text-align: center;
    color: #fff;
    margin: 0 auto;
  }
  .footer-mian-fixed .right span{
    display: inline-block;
    width: 100%;
  }
  .footer-mian-fixed .right span a{
    display: inline-block;
    width: 100%;
  }
</style>